<template>
  <a-modal
    :title="dialogTitle"
    :visible="visible"
    :mask-closable="false"
    :width="450"
    :confirm-loading="loading"
    destroy-on-close
    @cancel="handleCancel"
    @ok="handleOk('form')"
  >
    <a-form-model
      ref="form"
      :model="form"
      label-align="right"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
      :rules="validateRules"
    >
      <a-form-model-item
        label="姓名:"
        prop="fullName"
      >
        <a-input
          v-model="form.fullName"
          placeholder="请填写姓名"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item
        label="邮箱前缀:"
        prop="nickname"
      >
        <a-input
          v-model="form.nickname"
          placeholder="请填写邮箱前缀"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item
        label="手机号:"
        prop="phone"
      >
        <a-input
          v-model="form.phone"
          placeholder="请填写手机号"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item
        label="角色:"
        prop="roleType"
      >
        <a-radio-group
          v-model="form.roleType"
          :options="roleOptions"
          @change="roleTypeChange($event)"
        />
      </a-form-model-item>
      <div v-if="!isAdmin">
        <a-form-model-item
          label="操作权限:"
          prop="operatorPermissionIdList"
        >
          <a-checkbox-group
            v-model="form.operatorPermissionIdList"
            :options="permissionNamesOption"
            @change="onChange"
          />
        </a-form-model-item>
        <a-form-model-item
          label="基地权限"
          prop="baseIdList"
        >
          <a-select
            v-model="form.baseIdList"
            mode="multiple"
            placeholder="请选择基地权限"
            allow-clear
          >
            <a-select-option
              v-for="item in baseOptions"
              :key="item.baseId"
            >
              {{ item.baseName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </div>
    </a-form-model>
  </a-modal>
</template>

<script>
import { updateUser, addUser } from '@/api/userManage.js'
import moment from 'moment'
import { deepClone } from '@/utils/utils.js'

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    initData: {
      type: Object,
      default: null
    },
    dialogTitle: {
      type: String,
      default: null
    },
    baseOptions: {
      type: Array,
      default: null
    },
    permissionNames: {
      type: Array,
      default: null
    },
    actionType: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      form: {
        roleType: undefined,
        nickname: undefined,
        baseList: [],
        operatorPermissionIdList: [],
        phone: undefined,
        fullName: undefined
      },
      validateRules: {
        fullName: [{ required: true, message: '请输入姓名' }],
        nickname: [{ required: true, message: '请输入邮箱前缀' }],
        roleType: [{ required: true, message: '请选择角色' }],
        baseList: [{ required: true, message: '请选择基地' }],
        operatorPermissionIdList: [{ required: true, message: '请选择操作权限' }]
      },
      baseTemp: [],
      monthFormat: 'YYYY/MM',
      roleOptions: [{ label: '普通用户', value: 2 }, { label: '管理员', value: 1 }],
      isAdmin: 0,
      operatorPermissionId: undefined,
      permissionNamesOption: []

    }
  },
  watch: {
    visible: {
      deep: true,
      handler: function (data) {
        if (data) {
          this.form = this.deepClone(this.initData)
          this.isAdmin = 0

          this.permissionNamesOption = this.permissionNames.map((item) => {
            return {
              label: item.permissionName,
              value: item.permissionId
            }
          })
          if (this.actionType === '1') {
            this.form.operatorPermissionIdList = [1]
            this.form.roleType = 2
          }
          if (this.form.roleType === 1) {
            this.isAdmin = 1
          }
        }
      }
    }
  },
  methods: {
    moment,
    deepClone,
    handleCancel () {
      this.$refs.form.resetFields()
      this.$emit('cancel')
    },
    async handleOk () {
      if (!this.form.operatorPermissionIdList.includes(1)) {
        this.form.operatorPermissionIdList.push(1)
        // this.$message.success('默认必选查看权限，已为您自动添加!')
      }
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (this.actionType === '0') {
            await updateUser(
              { ...this.form }
            ).then((data) => {
              if (data) {
                this.$message.success('提交成功!')
                this.$emit('ok')
              } else {
                this.$message.error('提交失败!')
              }
            })
          } else {
            await addUser(
              { ...this.form }
            ).then((data) => {
              if (data) {
                this.$message.success('提交成功!')
                this.$emit('ok')
              } else {
                this.$message.error('提交失败!')
              }
            })
          }
        }
      })
    },
    roleTypeChange (e) {
      if (e.target.value === 1) {
        this.isAdmin = 1
      } else {
        this.isAdmin = 0
        this.form.operatorPermissionIdList.push(1)
      }
    },
    onChange (e) {
      if (!e.includes(1)) {
        this.form.operatorPermissionIdList.push(1)
      }
    }
  }
}
</script>
